import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {Button, Icon} from '@material-ui/core';
import {connect} from 'react-redux';
import _ from 'lodash';
import ReduxContacts from "../../../../store/actionreducers/trial_vip/contacts";
import ReduxTrialVip from "../../../../store/actionreducers/trialVip";
import {FusePageSimple, FuseAnimate} from '../../../../@fuse/index';
import ContactsList from './TrialVipList';
import ContactsHeader from './TrialVipHeader';
import TrialVipDialog from './TrialVipDialog';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import {constDataDialogs} from "../../../../constants";

const headerHeight = 160;

const styles = theme => ({
    root: {},
    avatar: {},
    layoutHeader: {
        height: headerHeight,
        minHeight: headerHeight
    },
    layoutContentCardWrapper: {
        padding: 24,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
    addButton: {
        position: 'absolute',
        right: 12,
        bottom: 12,
        zIndex: 99
    }
});

class TrialVipsApp extends Component {

    componentDidMount() {
        this.props.getContacts(this.props.match.params);
        this.props.getTrialVips();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.props.location, prevProps.location)) {
            this.props.getContacts(this.props.match.params);
        }
    }

    render() {
        const {classes, openLoadingMask, closeLoadingMask, openDataDialog, openAlertDialog, addTrialVip} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <ContactsHeader pageLayout={() => this.pageLayout}/>
                    }
                    content={
                        <ContactsList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <Button
                        variant="fab"
                        color="primary"
                        aria-label="add"
                        className={classes.addButton}
                        onClick={() => {

                            const alertDialogInfo = {
                                title: '請問要產生新的試用會員嗎?',
                                message: '',
                                yesButton: {
                                    label: '是',
                                    onClick: async () => {
                                        try {
                                            openLoadingMask();
                                            await addTrialVip();
                                            await closeLoadingMask();
                                            openDataDialog({type: 'edit', name: constDataDialogs.name.trialVipDialog});
                                        } catch (e) {
                                            console.warn('you got an error = ', e);
                                        }
                                    },
                                },
                                noButton: {label: '否'}
                            };

                            openAlertDialog(alertDialogInfo); // 新增測試帳號
                        }}>
                        <Icon>person_add</Icon>
                    </Button>
                </FuseAnimate>
                <TrialVipDialog/>
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addContact: ReduxContacts.ActionCreator.addContact,
        addTrialVip: ReduxTrialVip.ActionCreator.addTrialVip,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        getContacts: ReduxContacts.ActionCreator.getContacts,
        getTrialVips: ReduxTrialVip.ActionCreator.getTrialVips,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({contactsApp}) {
    return {
        contacts: contactsApp.contacts.entities,
        selectedContactIds: contactsApp.contacts.selectedContactIds,
        searchText: contactsApp.contacts.searchText,
        user: contactsApp.user
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(TrialVipsApp)));



// WEBPACK FOOTER //
// ./src/main/content/sales/trial_vip/TrialVipsApp.js